export default __webpack_public_path__ + "static/media/image05.7a2daea8.jpg";